import React, {useState} from 'react';
import './_toolbar.scss';
import VButton from "../../v-button/v-button";
import puzzles from "../../../utils/puzzles";

export default function Toolbar() {
    const [isShareMode, setIsShareMode] = useState(false);

    const MainToolbar = <div className='toolbar__item-list main-btn-list'>
        <VButton id='house_btn'
                 className='toolbar__item'
                 content={<img src="./assets/images/home.svg" alt="Home"/>}
                 tooltip='Show/Hide home model'
                 key='home'
                 onClick={() => puzzles.procedures?.toggleHouse()}
        />
        <VButton id='outside_btn'
                 className='toolbar__item'
                 content={<img src="./assets/images/scenery.png" alt="Scenery"/>}
                 tooltip='Show/Hide scenery'
                 key='scenery'
                 onClick={() => puzzles.procedures?.toggleScenery()}
        />
        <VButton id='360_btn' className='toolbar__item'
                 content={<img src="./assets/images/image360.svg" alt="360"/>}
                 tooltip='Rotate home model'
                 key='rotate'
                 onClick={() => puzzles.procedures?.switchMode()}
        />

        <VButton id='screenshot_btn' className='toolbar__item'
                 content={<img src="./assets/images/screen-shot.svg" alt="Screenshot"/>}
                 tooltip='Share or download'
                 key='screenshot'
                 onClick={() => {
                     setIsShareMode(true);
                     puzzles.procedures?.takeScreenshot();
                 }}
        />

        <VButton id='fs_button' className='toolbar__item'
                 content={<img src="./assets/images/full-screen.svg" alt="Fullscreen"/>}
                 tooltip='Maximize/minimize window'
                 key='fullscreen'
                    onClick={() => {
                        if (document.fullscreenElement) {
                            document.exitFullscreen();
                        } else {
                            document.body.requestFullscreen()
                        }
                    }}
        />
    </div>;

    const ShareToolbar = <div className='toolbar__item-list share-btn-list'>
        <VButton id='back_to_main_btn' className='toolbar__item'
                 content={<img src="./assets/images/back.svg" alt="Back"/>}
                 tooltip='Return to main menu'
                 onClick={() => {
                     setIsShareMode(false)
                 }}
                 key='back'
        />
        <VButton id='download_btn'
                 className='toolbar__item'
                 content={<img src="./assets/images/download.svg" alt="Download"/>}
                 tooltip='Download screenshot'
                 key='download'
                 onClick={() => puzzles.procedures?.downloadScreenshot()}
        />
        <VButton id='fb_btn'
                 className='toolbar__item'
                 content={<img src="./assets/images/facebook.svg" alt="Facebook"/>}
                 tooltip='Share on Facebook'
                 key='fb'
        />
        <VButton id='x_btn' className='toolbar__item'
                 content={<img src="./assets/images/x.svg" alt="X"/>}
                 tooltip='Share on X'
                 key='x'
        />

        <VButton id='linkedin_btn' className='toolbar__item'
                 content={<img src="./assets/images/linkedin.svg" alt="Linkedin"/>}
                 tooltip='Share on LinkedIn'
                 key='linkedin'
        />
    </div>

    return (<div className={"toolbar" + (isShareMode ? ' sharing' : '')}>
        {
            MainToolbar
        }
        {
            ShareToolbar
        }

    </div>);
}
